import { css, Global } from "@emotion/core";
import React from "react";
import Helmet from "react-helmet";
import bp from "../utils/media";

const globalStyle = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1.5625;
    font-family: "RationalTWText-Book";
    font-size: 16px;
    color: #000000;

    ${bp.medium} {
      line-height: 1.375;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Rational-Euroculture-Re-TWText-SemiBold";
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  html,
  button,
  input,
  textarea {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: "RationalTWText-Light";
  }

  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
  }

  strong {
    font-weight: bold;
  }

  .content-container {
    position: relative;
    padding: 0 62px;
    max-width: 1304px;
    margin: 0 auto;

    ${bp.medium} {
      padding: 0 17px;
    }
  }
  @font-face {
    font-family: "Rational-Euroculture-Re-TWText-SemiBold";
    src: url("/assets/fonts/Rational-Euroculture-Re-TWText-SemiBold.woff") format("woff");
  }
  @font-face {
    font-family: "RationalTWText-Book";
    src: url("/assets/fonts/RationalTWText-Book.woff2") format("woff2");
  }
`;

const Layout = ({ children }) => (
  <>
    <Global styles={globalStyle} />
    <Helmet>
      <link rel="stylesheet" href="https://use.typekit.net/iyr7cfu.css" />
      <meta name="google-site-verification" content="C7Cy6JR_xI-2rbygsVCRhWuib88yOVm5O6Nxd-4QUpA" />
      {/* <script
        id="Cookiebot"
        src="https://consent.cookiebot.com/uc.js"
        data-cbid="445a9cde-04d2-4286-a493-81ac39753143"
        data-blockingmode="auto"
        type="text/javascript"
      ></script> */}
    </Helmet>
    {children}
  </>
);

Layout.ContentContainer = ({ children }) => <div className="content-container">{children}</div>;

export default Layout;
